module.exports = __webpack_public_path__ + "img/in-stock.b8db62d.svg";